<template>
  <b-row>
    <b-col>
      <b-form-group :label="label" :label-for="fieldName">
        <b-form-timepicker
          :id="fieldName"
          :placeholder="placeHolder"
          :required="required"
          v-model="localValue"
          type="time"
          v-bind="$attrs"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeHolder: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
